

















import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {Sale} from "@/interfaces/entity/sale";
import {SaleStore} from "@/modules/sale/store";


@Component({
    name: "SaleTableAction"
})
export default class extends mixins(CommonMixin){
    @Prop({required: true, type: Number})
    readonly saleId!: number;
    
    get sale(): Sale {
        return SaleStore.data[this.saleId];
    }
    
    set sale(value: Sale) {
        SaleStore.data[this.saleId] = value;
    }
    
    async onConfirm() {
        try {
            await SaleStore.deleteSale(this.saleId);
            this.$notification.success({
                message: "Thành công",
                description: "Xóa thành công"
            });
        } catch (e) {
            this.$notification.error({
                message: "Thất bại",
                description: "Xóa thất bại"
            });
        }
    }
}
